var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.972,
    height: 26.252,
    viewBox: "0 0 24.972 26.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2470",
    "data-name": "Group 2470",
    transform: "translate(-2.25 -1.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9951",
    "data-name": "Path 9951",
    d: "M19.092,27.161H9.257A3.906,3.906,0,0,1,5.416,23.5L4.25,5.774a.973.973,0,0,1,.256-.7.986.986,0,0,1,.7-.32H23.139a.96.96,0,0,1,.96,1.024L22.986,23.5a3.906,3.906,0,0,1-3.893,3.663ZM6.286,6.671l.986,16.712A1.985,1.985,0,0,0,9.257,25.24h9.835a2,2,0,0,0,1.985-1.857L22.115,6.735Z",
    transform: "translate(0.561 0.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9952",
    "data-name": "Path 9952",
    d: "M26.261,6.671H3.21a.96.96,0,1,1,0-1.921H26.261a.96.96,0,0,1,0,1.921Z",
    transform: "translate(0 0.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9953",
    "data-name": "Path 9953",
    d: "M16.894,7.513H9.21a.973.973,0,0,1-.96-.96V4.247a2.561,2.561,0,0,1,2.5-2.5h4.61a2.561,2.561,0,0,1,2.5,2.561V6.552a.973.973,0,0,1-.96.96ZM10.171,5.592h5.763V4.311a.576.576,0,0,0-.576-.576h-4.61a.576.576,0,0,0-.576.576Z",
    transform: "translate(1.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9954",
    "data-name": "Path 9954",
    d: "M15.21,20.916a.973.973,0,0,1-.96-.96V9.71a.96.96,0,1,1,1.921,0V19.955A.973.973,0,0,1,15.21,20.916Z",
    transform: "translate(3.367 1.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9955",
    "data-name": "Path 9955",
    d: "M9.21,20.916a.973.973,0,0,1-.96-.96V9.71a.96.96,0,0,1,1.921,0V19.955A.973.973,0,0,1,9.21,20.916Z",
    transform: "translate(1.684 1.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9956",
    "data-name": "Path 9956",
    d: "M12.21,20.916a.973.973,0,0,1-.96-.96V9.71a.96.96,0,1,1,1.921,0V19.955A.973.973,0,0,1,12.21,20.916Z",
    transform: "translate(2.525 1.964)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.05f07a12b263170bc4601aa73c331aaa.svg";
export { ForwardRef as ReactComponent };